import { Box } from "@mui/material";
import React from "react";
import { Color } from "../constants";

const styles = {
  hamburger: {
    width: "30px",
    height: "25px",
    position: "relative",
    cursor: "pointer",
  },
  hamburgerLine: {
    width: "100%",
    borderRadius: "2px",
    height: "5px",
    display: "block",
    backgroundColor: "black",
    position: "absolute",
    transition: "opacity 0.2s ease-in-out 0s, transform 0.2s ease-in-out 0s",
  },
};

// artifact from landing site; if used, should pass in from NavBar
const darkMode = false;

const Hamburger = ({ open, setOpen }) => {
  return (
    <Box
      sx={{
        ...styles.hamburger,
      }}
      onClick={() => setOpen(!open)}>
      <Box
        sx={{
          ...styles.hamburgerLine,
          top: "0px",
          transform: open ? "rotate(45deg) translate(25%, 125%)" : "none",
          ...(darkMode && { backgroundColor: Color.primary }),
        }}
      />
      <Box
        sx={{
          ...styles.hamburgerLine,
          top: "10px",
          opacity: open ? "0" : "1",
          ...(darkMode && { backgroundColor: Color.primary }),
        }}
      />
      <Box
        sx={{
          ...styles.hamburgerLine,
          top: "20px",
          transform: open ? "rotate(-45deg) translate(25%, -125%)" : "none",
          ...(darkMode && { backgroundColor: Color.primary }),
        }}
      />
    </Box>
  );
};

export default Hamburger;
